import React, { useState } from 'react';
import { neon } from '@netlify/neon';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dialog from '../components/dialogBox';
import { Link } from "react-router-dom";
import './UserPage.css'

const sql = neon(import.meta.env.VITE_NETLIFY_DATABASE_URL); // Automatically uses env NETLIFY_DATABASE_URL
const UserPage = ({user_id, setUser_id}) => {
	console.log(user_id);
  const [formData, setFormData] = useState({
    storeName: '',
    contact: '',
    address: '',
    phone: '',
    email: '',
  });

  const [errors, setErrors] = useState({
    storeName: '',
    contact: '',
    address: '',
    phone: '',
    email: '',
  });

  const [showDialog, setShowDialog] = useState(false);
 const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const showAlert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setShowDialog(true);
  };

  const validate = () => {
    const newErrors: typeof errors = {
      storeName: '',
      contact: '',
      address: '',
      phone: '',
      email: '',
    };
    if (!formData.storeName) newErrors.storeName = 'Store Name is required';
    if (!formData.contact) newErrors.contact = 'Contact is required';
    if (!formData.address) newErrors.address = 'Address is required';
    if (!formData.phone) newErrors.phone = 'Phone is required';
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email address';
    }
    setErrors(newErrors);
  return Object.values(newErrors).every(error => error === '');
    // return Object.keys(newErrors).length === 0;
    return true;
  };


const insertData = async (formData: any) => {
  try {
    const [result] = await sql`
      INSERT INTO issby_user (
        store_name, contact_name, address, phone, email) VALUES (
        ${formData.storeName}, ${formData.contact}, ${formData.address}, ${formData.phone}, ${formData.email}) RETURNING id;
    `;
    console.log('Data inserted successfully:', result);
    setUser_id(result.id)
  } catch (error) {
    console.error('Error inserting data:', error);
  }
};
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {

 e.preventDefault();
 console.log(validate())
    if (validate()) {
      try {
	  console.log("validate");
        await insertData(formData);
	showAlert('Account created', 'Your information is submitted successfully')
      } catch (error) {
	showAlert('Account not created', 'Your information not submitted')
        console.error('Error submitting data:', error);
      }
    }
  };


  return (
      <div className="container">

      <h1>Create an Account</h1>
      <form onSubmit={handleSubmit}>
          <input
	  id="nme"
            type="text"
            name="storeName"
            value={formData.storeName}
            placeholder='Retail Store Name'
	    className="question"
            onChange={handleChange}
            style={{}}
          />
<label htmlFor="nme"><span>Store Name</span></label>
          {errors.storeName && <span style={{ color: 'red', fontSize: '12px' }}>{errors.storeName}</span>}
          <input
	  id="nme"
            type="text"
            name="contact"
            value={formData.contact}
            placeholder='John Doe'
            onChange={handleChange}
	    className="question"
            style={{}}
          />
<label htmlFor="nme"><span>Contact Name</span></label>
          {errors.contact && <span style={{ color: 'red', fontSize: '12px' }}>{errors.contact}</span>}
          <input
	  id="nme"
            type="text"
            name="address"
            placeholder='514 Jackson St'
            value={formData.address}
	    className="question"
            onChange={handleChange}
            style={{}}
          />
          {errors.address && <span style={{ color: 'red', fontSize: '12px' }}>{errors.address}</span>}
<label htmlFor="nme"><span>Physical Address</span></label>
          <input
	  id="nme"
            type="text"
            name="phone"
            placeholder='6242083901'
            value={formData.phone}
	    className="question"
            onChange={handleChange}
            style={{}}
          />
          {errors.phone && <span style={{ color: 'red', fontSize: '12px' }}>{errors.phone}</span>}
<label htmlFor="nme"><span>Phone</span></label>
          <input
	  id="nme"
            type="email"
            name="email"
            placeholder='john.doe@gmail.com'
            value={formData.email}
	    className="question"
            onChange={handleChange}
            style={{}}
          />
          {errors.email && <span style={{ color: 'red', fontSize: '12px' }}>{errors.email}</span>}
<label htmlFor="nme"><span>Email</span></label>
        <Link to="/product_db" style={{ textDecoration: 'none', color: '#000', margin: '80%'}}>
          <button type="submit" style={{ padding: '10px 20px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
            Submit & Proceed to next page
          </button>
  
</Link>
      </form>
      <div style={{display: 'flex', justifyContent: 'center', gap: '20em'}}>
      <h4 style={{marginLeft: '2em'}}>Page 2 of 3</h4>
      </div>

{/* 
        <Link to="/product_db" style={{ textDecoration: 'none', color: '#000', margin: '90%'}}>
        <a style={{ padding: '10px 20px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer'}}>
          Next
        </a>
</Link>*/}
      {showDialog && (
 <Dialog
        titler={alertTitle}
        message={alertMessage}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
      />
      )}
      </div>
  );
};

export default UserPage;
